const newTermsAndAgreements = {
  canadaMar2021: 'canada_mar_2021',
  franceJul2021: 'france_july_2021',
  franceDec2021: 'france_dec_2021',
};

export default newTermsAndAgreements;
